export default __webpack_public_path__ + "static/media/7000ROUGE.dc9542eb.pdf";